import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Carousel } from '@grandvisionhq/common';
import { VariantSwitcherItem } from './components/VariantSwitcherItem/VariantSwitcherItem.js';

const VariantSwitcher = ({ variants , activeSku , onVariantChange , className , tabIndex ,  })=>{
    const [activeIndex, setActiveIndex] = React.useState(0);
    const itemsPerSlide = MediaQuery.useIsPhone() ? 2 : 3;
    const carouselItems = React.useMemo(()=>{
        const max = Math.ceil(variants.length / itemsPerSlide);
        const items = [];
        for(let i = 0; i < max; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(/*#__PURE__*/ React.createElement("div", {
                key: `variant-switcher-${i}`,
                className: classnames('variant-switcher__slide', {
                    'variant-switcher__slide--single': max === 1
                })
            }, variants.slice(start, end).map(({ sku , images  })=>{
                 return React.createElement(VariantSwitcherItem, {
                    key: sku,
                    image: images === null || images === void 0 ? void 0 : images[0],
                    sku: sku,
                    isActive: sku === activeSku,
                    onClick: onVariantChange,
                    disableTabIndex: tabIndex === -1 || activeIndex !== i
                });
            })));
        }
        return items;
    }, [
        variants,
        itemsPerSlide,
        activeSku,
        onVariantChange,
        tabIndex,
        activeIndex
    ]);
    if (variants.length <= 1) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('variant-switcher', className)
    }, /*#__PURE__*/ React.createElement(Carousel, {
        onIndexChange: setActiveIndex,
        shouldLoopNavigationFocus: true
    }, carouselItems));
};

export { VariantSwitcher };
//# sourceMappingURL=VariantSwitcher.js.map
